import { render, staticRenderFns } from "./CheckoutFeatureTab.vue?vue&type=template&id=617a97fc&scoped=true"
import script from "./CheckoutFeatureTab.vue?vue&type=script&lang=js"
export * from "./CheckoutFeatureTab.vue?vue&type=script&lang=js"
import style0 from "./CheckoutFeatureTab.vue?vue&type=style&index=0&id=617a97fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a97fc",
  null
  
)

export default component.exports